import styled from 'styled-components'

export const PasswordTitle = styled.h1`
    font-weight: normal;
    @media screen and (max-width: 992px) {
        font-size: 1.5rem;
    }
`
